import createStoreSlice from '../Utils/createStoreSlice';

const { reducer, useStore, useStoreHandlers } = createStoreSlice({
  name: 'chatReducer',
  states: {
    chatMode: 'USER',
    openChatInfo: {},
    chatId: null,
    unreadCount: {
      total: 0,
      user: 0,
      group: 0,
    },
    chatListingSearchQuery: '',
    currentUserInfo: {},
    usersInfo: {
      listing: [],
      loading: false,
    },
    groupsInfo: {
      listing: [],
      loading: false,
    },
    socket: null,
    isConnected: false,
    aiChats: []
  },
});

export {
  reducer as chatReducer,
  useStore as useChatStore,
  useStoreHandlers as useChatStoreHandlers,
};
